module.exports = __webpack_public_path__ + "static/r3-5f0a6e64c91ae9f93758c873eb73d0e3.png";